import type { Locale } from "@laftel-ip-originals/notion/locale";

export interface GoodsTitleParts {
  workName: string;
  subtitle: string;
  locale: Locale;
}

export function formatGoodsTitle({ workName, subtitle, locale }: GoodsTitleParts): string {
  if (locale === "ko") return `<${workName}> ${subtitle}`;
  if (locale === "ja") return `『${workName}』 ${subtitle}`;
  return `${workName} ${subtitle}`;
}

export function GoodsTitle({ parts }: { parts: GoodsTitleParts }) {
  if (parts.locale === "en") {
    return (
      <>
        <i>{parts.workName}</i> {parts.subtitle}
      </>
    );
  }
  return <>{formatGoodsTitle(parts)}</>;
}
